import React, {useEffect, useState} from 'react'
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../Images/no-data-found.webp";
import '../main_2.css'

const Dealer = ({
                    getDetails,
                    getDealerDetails,
                    match
                }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getDetails()
            setIsLoading(false)
        })()
    }, [])


    const onPageChange = async (val) => {
        setIsLoading(true)
        await getDetails(val?.selected + 1, searchValue, match?.params?.dealer_type)
        setIsLoading(false)
    };

    const handleSearch = async () => {
        setIsLoading(true)
        if(searchValue){
            window.localStorage.search_account = searchValue
        }
        await getDetails(1, searchValue, match?.params?.dealer_type)
        setIsLoading(false)
    }

    const removeSearchFilter = async () => {
        delete window.localStorage.search_account
        setIsLoading(true)
        await getDetails()
        setIsLoading(false)
    }

    const handleKeyPress = (e) => {
        
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
        }
      };

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Dealer List'}
                        />
                        <div className="container-fluid common-bg">
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="row b-13">
                                </div>
                                <div className="d-sm-flex align-items-center justify-content-between mt-2 mb-2">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px">
                                            <form className="form-inline mr-auto w-100 navbar-search">
                                                <div className="d-flex w-100">
                                                    <input type="text"
                                                           onKeyPress={handleKeyPress}
                                                           className="form-control bg-light border-0 small list-filter"
                                                           placeholder={"Search Dealer ..."}
                                                           aria-label="Search"
                                                           aria-describedby="basic-addon2"
                                                           onChange={(e) => {
                                                               setSearchValue(e.target.value)
                                                           }}
                                                    />
                                                    <div className="remove-search-filter">
                                                        <i className="fa fa-times" aria-hidden="true" onClick={removeSearchFilter}></i>
                                                    </div>
                                                    <div className="btn-search">
                                                        <button className="btn btn-primary lh-32 border-left-tr-tb"
                                                                type="button"
                                                                onClick={(e) => handleSearch()}
                                                        >
                                                            <i className="fas fa-search fa-sm"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {/*CARD START*/}
                                    {getDealerDetails && getDealerDetails?.data !== undefined && getDealerDetails?.data?.resultSets !== undefined && getDealerDetails?.data !== [] && getDealerDetails?.data?.resultSets.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    {/*<div className="header-ui-item"*/}
                                                                    {/*     style={{backgroundColor: val?.stage_color}}>*/}
                                                                    {/*    {val?.stage_name}*/}
                                                                    {/*</div>*/}
                                                                    <div className="row">
                                                                        <div className="col-10" style={{
                                                                            color: "#000",
                                                                            fontSize: "20px",
                                                                            textAlign: "left",
                                                                            paddingLeft: "20px"
                                                                        }}>
                                                                            <div className="d-flex">
                                                                                {val?.legal_name + "(" + val?.dealer_id + ")"}
                                                                            </div>

                                                                        </div>

                                                                        <div className="dropdown"
                                                                                                 style={{"float": "right"}}>
                                                                                                <i className="bi bi-three-dots-vertical" data-toggle="dropdown" style={{color:"black"}}></i>
                                                                                                <ul className="dropdown-menu">
                                                                                                    <li><a
                                                                                                        href={`add-poc/${val?.dealer_id}`}
                                                                                                        className="btn btn-sm"
                                                                                                        type="button"
                                                                                                    >Add POC</a>
                                                                                                    </li>
                                                                                                    
                                                                                                </ul>
                                                                                            </div>
                                                                    </div>
                                                                    <div className="row list-view">
                                                                        {val?.trade_name !== null &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fas fa-globe"></i>&nbsp;&nbsp;Trade
                                                                                    Name
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.trade_name}>
                                                                                        {val?.trade_name}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-map"></i>&nbsp;&nbsp;Brand
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.brand}
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-address-card"
                                                                                   aria-hidden="true"></i>&nbsp;&nbsp;Address
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.full_address}>
                                                                                        {val?.full_address}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr/>
                                                                    <div className="row list-view-links"
                                                                         style={{padding: "12px"}}>
                                                                        <ul>
                                                                            <li>
                                                                                {val?.stage_name !== 'Draft' &&
                                                                                    <li style={{margin: "-8px"}}><a
                                                                                        href={`health-card/${val?.dealer_id}`}
                                                                                    >
                                                                                        <i className="fa fa-plus-square"></i>&nbsp;&nbsp;Health Card</a>
                                                                                    </li>
                                                                                }
                                                                            </li>
                                                                            {val?.stage_name !== 'Draft' &&
                                                                                <li style={{margin: "-8px"}}><a
                                                                                    href={`dealer-activity-list/${val?.dealer_id}`}
                                                                                >
                                                                                    <i className="bi bi-list"></i>&nbsp;&nbsp;Activity</a>
                                                                                </li>
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}

                                    {getDealerDetails && getDealerDetails?.data !== undefined && getDealerDetails?.data?.resultSets !== undefined && getDealerDetails?.data?.resultSets.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(getDealerDetails?.data?.total / getDealerDetails?.data?.per_page)}
                                                forcePage={getDealerDetails?.data?.current_page - 1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }

                                    {getDealerDetails && getDealerDetails?.data !== undefined && getDealerDetails?.data?.resultSets.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="Dealer not found" alt={""}/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Dealer